/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconRefreshAlert = createReactComponent("refresh-alert", "IconRefreshAlert", [
  ["path", { d: "M20 11a8.1 8.1 0 0 0 -15.5 -2m-.5 -4v4h4", key: "svg-0" }],
  ["path", { d: "M4 13a8.1 8.1 0 0 0 15.5 2m.5 4v-4h-4", key: "svg-1" }],
  ["path", { d: "M12 9l0 3", key: "svg-2" }],
  ["path", { d: "M12 15l.01 0", key: "svg-3" }]
]);

export { IconRefreshAlert as default };
//# sourceMappingURL=IconRefreshAlert.js.map
